import type { ClipperRankFamily } from './types';

function familyFromTierId(tierId: string): ClipperRankFamily {
  const dot = tierId.indexOf('.');
  const id = dot === -1 ? tierId : tierId.slice(0, dot);
  return {
    id,
    featured_tier_id: tierId,
    badges: [{ tier_id: tierId }],
  };
}

export function resolveRowFamilies({
  families,
  title_id,
  current_tier_ids,
  views_tier_id,
}: {
  families?: ClipperRankFamily[] | null;
  title_id?: string | null;
  current_tier_ids?: string[] | null;
  views_tier_id?: string | null;
}): ClipperRankFamily[] {
  if (families?.length) return families;

  const result: ClipperRankFamily[] = [];
  const seenIds = new Set<string>();

  if (title_id) {
    const season = familyFromTierId(title_id);
    season.id = 'season';
    result.push(season);
    seenIds.add('season');
  }

  for (const tierId of current_tier_ids ?? []) {
    const family = familyFromTierId(tierId);
    if (seenIds.has(family.id)) continue;
    result.push(family);
    seenIds.add(family.id);
  }

  if (views_tier_id && !seenIds.has('views')) {
    result.push(familyFromTierId(views_tier_id));
  }

  return result;
}
